import { render, staticRenderFns } from "./AddFamilyMember.vue?vue&type=template&id=6cc82fc1&scoped=true"
import script from "./AddFamilyMember.vue?vue&type=script&lang=ts"
export * from "./AddFamilyMember.vue?vue&type=script&lang=ts"
import style0 from "./AddFamilyMember.vue?vue&type=style&index=0&id=6cc82fc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc82fc1",
  null
  
)

export default component.exports